export default {
  app: {
    title: 'Transfer Service',
    subtitle: '预约、查单和支付状态查询',
    language: '语言'
  },
  common: {
    ok: '确定',
    systemError: '系统异常'
  },
  notFound: {
    title: '页面不存在',
    description: '你访问的页面不存在，可能链接已失效或地址输入有误。'
  },
  action: {
    booking: '预约用车',
    queryOrder: '查询订单',
    submit: '提交',
    continue: '继续',
    cancel: '取消',
    backHome: '返回首页',
    expand: '展开',
    collapse: '收起',
    delete: '删除',
    yes: '是',
    no: '否'
  },
  booking: {
    title: '预约用车',
    successTitle: '预约已提交',
    successDescription: '请保存订单号码和查询码，后续可使用订单号码、邮箱和查询码查询。',
    successOrderNo: '订单号码',
    successQueryCode: '订单查询码',
    customerInfo: '客户信息',
    appointments: '预约行程',
    multiAppointmentHint: '一个订单可以包含多个预约行程。',
    appointmentTitle: '预约 {index}',
    basicInfo: '基本信息',
    flightAndAddress: '航班和地点',
    extraServices: '附加服务',
    addAppointment: '新增预约',
    snowboardHint: '4人以上携带高尔夫/滑雪包建议使用 Hiace',
    babySeatLabel: '儿童座椅（{free}个免费，第{from}个起 {price}/个）',
    babySeatSimpleHint: '第2个起 +¥1,500 / 个',
    supermarketPriceItem: '{hour}小时 {price}',
    tripEstimate: '本行程预估费用',
    totalEstimate: '订单预估总额',
    addTripDetail: '新增行程详细',
    priceBreakdown: {
      baseFare: '车费',
      earlyLateSurcharge: '早晚时间加价 {percent}',
      babySeat: '儿童座椅',
      supermarketStop: '超市停留'
    },
    verifyEmailAndContinue: '验证邮箱并继续',
    sendEmailCode: '发送邮箱验证码',
    resendEmailCode: '重新发送验证码',
    resendCountdown: '{seconds} 秒后重新发送',
    emailCodeSent: '验证码已发送，请输入邮箱验证码。',
    emailVerified: '邮箱格式验证通过',
    emailVerificationTitle: '邮箱验证',
    emailVerificationDescription: '请发送邮箱验证码并完成验证后提交预约。',
    verifyAndSubmit: '验证并提交',
    carInfo: '车型信息',
    field: {
      name: '姓名',
      email: '邮箱',
      phone: '电话',
      verifyCode: '验证码',
      serviceType: '商品名称',
      date: '配车日期',
      product: '商品名',
      transferRoute: '接送路线',
      carType: '车型',
      passengers: '人数',
      luggage: '行李合计数量',
      snowboard: '高尔夫/滑雪包',
      flightNo: '航班号',
      flightTime: '航班时间',
      arrivalTime: '到达时间',
      departureTime: '迎车时间',
      pickupAddress: '上车地点',
      meetingPlace: '会面地点',
      dropoffAddress: '目的地',
      customDropoffAddress: '自定义目的地',
      tripDetails: '行程详细',
      tripDetailTitle: '行程详细 {index}',
      remark: '备注',
      supermarketStop: '超市停留'
    },
    unit: {
      pieces: '{count} 个'
    },
    airportTerminal: {
      international: '国际线',
      domestic: '国内线'
    },
    serviceType: {
      airportPickup: '机场出发的行程',
      airportDropoff: '出发去机场的行程',
      pointToPoint: '接送路线列表'
    },
    supermarketOption: {
      none: '不需要',
      oneHour: '1小时',
      twoHours: '2小时',
      threeHours: '3小时'
    },
    surchargeHint: {
      pickup: '早上{before}之前或晚上{after}之后的行程需要加车费价格的{percent}。',
      departure: '早上{before}之前或晚上{after}之后出发的行程需要加车费价格的{percent}。'
    },
    validation: {
      nameRequired: '请输入姓名',
      emailRequired: '请输入邮箱',
      emailInvalid: '请输入有效的邮箱地址',
      emailNotVerified: '请先验证邮箱',
      emailCodeNotSent: '请先发送邮箱验证码',
      verifyCodeInvalid: '验证码不正确',
      verifyCodeInvalidRetry: '验证码不正确或已过期，请重新发送验证码后再验证。',
      phoneRequired: '请输入电话',
      dateRequired: '预约 {index}: 请选择日期',
      noAvailablePricePeriod: '预约 {index}: 当前商品从今天开始没有有效价格期间',
      dateOutOfPricePeriod: '预约 {index}: 所选日期不在商品有效价格期间内',
      productRequired: '预约 {index}: 请选择商品',
      carTypeRequired: '预约 {index}: 请选择车型',
      passengersRequired: '预约 {index}: 请选择人数',
      passengersOverCarLimit: '预约 {index}: 当前车型最多可乘坐 {max} 人',
      flightNoRequired: '预约 {index}: 请输入航班号',
      timeRequired: '预约 {index}: 请输入{field}',
      pickupAddressRequired: '预约 {index}: 请输入出发地点',
      dropoffAddressRequired: '预约 {index}: 请输入目的地',
      tripDetailRequired: '预约 {index}: 请输入行程详细',
      tripDetailMaxLength: '预约 {index}: 行程详细最多输入500个字符'
    }
  },
  order: {
    queryTitle: '查询订单',
    detailTitle: '订单详情',
    tokenQueryDescription: '请输入预约查询 token。系统会先验证 token，验证通过后进入预约详情。',
    tokenPlaceholder: '请输入预约查询 token',
    checking: '正在查询...',
    invalidTitle: '预约链接无效或已过期',
    invalidDescription: '没有找到对应预约，或该查询 token 已失效。请确认 token 是否完整，或联系工作人员重新获取。',
    orderInfo: '订单信息',
    orderStatus: '订单状态',
    paymentStatus: '支付状态',
    loading: '正在加载订单详情...',
    tripItems: '行程明细',
    sendVerifyCode: '获取验证码',
    verifyAndViewDetail: '验证并查看订单详情',
    resendCode: '重新获取',
    resendCountdown: '{seconds} 秒后重新获取',
    verifyCodeSent: '验证码已发送，请查看预约邮箱。',
    forgotVerifyCode: '忘记验证码了吗？',
    mockVerifyCodePlaceholder: '',
    field: {
      orderNo: '订单号',
      email: '邮箱',
      verifyCode: '验证码',
      token: '查询 token'
    },
    detail: {
      orderNo: '订单号',
      appointmentId: '预约ID',
      customerInfo: '客户信息',
      basicInformation: '基本信息',
      flightAndAddress: '航班和地点',
      extraServices: '附加服务',
      dateOfService: '服务日期',
      carTypeMinMax: '车型（最少～最多）',
      passengerCount: '乘客人数',
      totalLuggage: '行李总数',
      snowboard: '高尔夫/滑雪包',
      flightNumber: '航班号',
      flightTime: '航班时间',
      meetingPlace: '集合地点',
      destination: '目的地',
      seat: '座椅',
      supermarketStop: '超市停留',
      deliveryInfo: '配车信息',
      deliveryStatus: '配车状态',
      dispatched: '已配车',
      notDispatched: '未配车',
      driverInfoVisibleSoon: '已配车，司机和车辆信息将在出发前3天显示。',
      vehicle: '车辆',
      licensePlate: '车牌',
      driver: '司机',
      phone: '电话',
      estimatedArrival: '预计到达',
      waitingPlace: '等待地点'
    },
    validation: {
      orderNoRequired: '请输入订单号',
      emailRequired: '请输入邮箱',
      verifyCodeRequired: '请输入验证码',
      tokenRequired: '请输入查询 token'
    },
    status: {
      0: '待确认',
      1: '已确认',
      pending: '待确认',
      confirmed: '已确认',
      quoted: '已报价',
      cancelled: '已取消',
      completed: '已完成',
      unknown: '未知状态'
    },
    info: {
      startDate: '开始日期',
      companyId: '代理店ID',
      bidStartTime: '入札开始时间',
      paymentAmount: '支付金额',
      paymentEmail: '支付邮箱',
      paymentEmailName: '支付邮箱姓名',
      paymentTaskId: '支付任务ID',
      paymentUrl: '支付链接',
      paymentStripePid: 'Stripe 支付ID',
      creator: '创建者',
      createTime: '创建时间',
      updater: '更新者',
      updateTime: '更新时间',
      branch: '预约分支',
      copyBranch: '复制分支',
      carType: '车种',
      people: '人',
      passengers: '乘客人数',
      flight: '航班及号码',
      flightDepartureTime: '航班出发时间',
      arrivalTime: '班机抵达时间',
      departureTime: '迎车时间',
      boardAddress: '上车地点',
      destination: '目的地',
      customerName: '客户姓名',
      customerPhone: '客户电话',
      customerEmail: '客户邮箱',
      babySeat: '儿童座椅',
      remark: '备注',
      amount: '金额',
      cancelFee: '取消费用'
    },
    appointmentCount: '{count} 个预约',
    noAppointments: '此订单暂未包含预约明细。',
    feeDetails: '费用明细',
    invoiceNo: '发票编号',
    payNoticeNo: '付款通知编号',
    carrierInvoiceNo: '承运商发票编号',
    processStatus: '处理状态',
    sellPrice: '卖价',
    grossPrice: '总价',
    netPrice: '净价',
    fee: '手续费',
    otherFee10: '其他费用 (10%)',
    otherFee8: '其他费用 (8%)',
    administratorMemo: '管理员备注'
  },
  payment: {
    title: '账单和支付',
    billNumber: '账单编号',
    billDate: '账单日期',
    deadline: '账单截止日期',
    receivedDate: '入账日期',
    totalFee: '费用总额',
    currentBillAmount: '当前账单金额',
    orderTotalAmount: '订单总金额',
    amountToPayNow: '本次需支付金额',
    amountToPayNowHint: '点击付款时，将按这个金额生成新的 Stripe 支付页面。',
    paidAmount: '已收金额',
    unpaidAmount: '待支付金额',
    refundAmount: '待返还金额',
    refundAmountPending: '待返还金额',
    refundAmountRefunded: '已返还金额',
    refundAmountPartial: '部分已返还金额',
    appointmentAmount: '预约费用',
    appointmentFeeDetails: '每个预约的费用明细',
    originalAppointmentAmount: '原预约费用',
    cancelFee: '取消料',
    cancelStatus: '取消状态',
    cancelStatusBeforePayment: '支付前取消，无需支付和返金',
    cancelStatusPaymentRequired: '取消后需支付取消料',
    cancelStatusAfterPaymentNoRefund: '支付后取消，无需返金',
    cancelStatusRefundPending: '支付后取消，待返金',
    cancelStatusPartialRefunded: '支付后取消，部分已返金',
    cancelStatusRefunded: '支付后取消，已返金',
    remark: '备注',
    downloadInvoice: '下载账单',
    payNow: '立即付款',
    collectByHotel: '请将费用支付给酒店或旅行社。',
    collectByDriver: '请将费用支付给司机。',
    downloadSuccess: '账单下载成功',
    paymentUrlEmpty: '未获取到支付链接',
    status: {
      0: '待支付',
      1: '已支付',
      2: '支付失败',
      not_requested: '未请求支付',
      unpaid: '待支付',
      pending: '支付处理中',
      paid: '已支付',
      timeout: '支付超时',
      additionalRequired: '需追加支付',
      partial: '部分支付',
      failed: '支付失败',
      expired: '已过期',
      refunded: '已退款',
      unknown: '未知状态'
    }
  },
  message: {
    title: '留言 / 联系我们',
    description: '如需修改行程、补充信息或咨询支付问题，请在这里留言。',
    field: '留言内容',
    target: '留言对象',
    orderTarget: '整个订单',
    itemTarget: '行程 {index}',
    itemMessageButton: '给此行程留言',
    placeholder: '请输入留言内容',
    submit: '提交留言',
    close: '关闭',
    history: '留言和回复',
    empty: '暂无留言',
    customer: '我的留言',
    staff: '客服回复',
    validationRequired: '请输入留言内容',
    maxLengthExceeded: '留言内容不能超过 {max} 字',
    submitSuccess: '留言已提交'
  },
  policy: {
    eyebrow: 'Notice & Policy',
    title: '注意事项',
    description: 'Madoras 专车送迎',
    noticeTitle: '',
    cancelTitle: '预约变更／取消政策',
    noticeItems: [
      '1.1 预约截止时间\n请至少在出发日期前 7天 完成预约。',
      '1.2 变更／取消手续费\n出发前 7天内 取消或修改预约，将按照下方的取消政策收取手续费。',
      '1.3 信息填写错误\n请务必正确填写预约信息。我们将根据您提供的信息安排车辆。\n如果因信息填写错误导致无法正常安排车辆，即使已付款，也无法退款。',
      '1.4 未按时出现（No Show）\n如果司机已到达并尝试联系您，但您没有出现，将视为 No Show（未按时乘车），恕不退款。',
      '1.5 付款\n建议尽早付款。\n由于汇款确认可能需要几天时间，我们将在确认收到款项后开始安排车辆，因此建议您尽早完成付款。',
      '1.6 集合地点\n根据乘车人数不同，可能需要前往指定集合地点乘车。具体地点将在确认邮件中通知您。',
      '1.7 天气等不可抗力\n如因天气、交通状况、道路封闭或其他不可抗力导致接送延误或取消，恕不退款。',
      '1.8 航班取消或延误\n如果航班取消或延误，请务必立即联系我们。电话：+81-11-215-1962\n我们会确认是否可以：让车辆继续等待；重新安排车辆；或确认无法安排。\n如果航班延误但没有提前联系我们，司机离开后将视为 No Show（未按时乘车），恕不退款。',
      '1.9 旺季／淡季价格调整\n网站显示的价格适用于出发前 7天以上的预约。\n距离出发不足7天的临时预约，价格可能至少加收20%。',
      '1.10 清晨／深夜附加费\n以下时间段需加收 20% 附加费：\n清晨：接车时间 早于上午6:30\n深夜：航班抵达时间 晚于晚上9:30',
      '1.11 中途停靠（Stopover）\n如果需要途中停靠，我们会重新计算行程，并另外报价。',
      '1.12 价格调整\nMadoras 有权根据旺季、淡季等情况调整价格。'
    ],
    cancelItems: [
      '1. 联系方式\n如需取消或修改预约，请在营业时间内通过以下方式联系我们：\n邮箱：info@madoras.net\n电话：+81-11-252-9966\nbooking@madoras.net为自动收件邮箱，不接受取消或修改申请。',
      '2. 回复时间\n营业时间：上午9:00～下午6:00。\n营业时间外收到的咨询，将于下一个营业日回复。',
      '3.取消手续费:\n出发前 7天～2天：收取 30%\n出发前一天 中午12:00之前：收取 50%\n出发前一天 中午12:00之后 或 出发当天：收取 100%',
      '4. 出发前7天内修改预约\n如果在出发前7天内需要修改预约，需取消原预约并重新预约，同时需支付相应的取消手续费。',
      '5. 出发前7天内的变更\n距离出发不足7天时，无论是取消预约还是修改预约，均按照上述取消手续费标准收费。',
      '6. 出发前7天以上取消\n如果在出发前 7天以上 取消预约，可获得全额退款，但需扣除 6% 的退款手续费（Handling Charge）。',
      '感谢您的理解与配合，期待为您服务。'
    ]
  },
  error: {
    title: '无法继续',
    requestFailed: '请求失败，请稍后重试',
    orderCredentialMismatch: '订单号和邮箱不匹配，请确认后重试。',
    invalidVerifyCode: '验证码不正确，请重新输入。',
    verifyCodeTooFrequent: '请稍后再重新发送验证码。',
    orderNotFound: '未找到订单，请确认订单号和邮箱。',
    bookingTokenInvalid: '订单链接无效或已过期，请确认链接是否完整，或联系工作人员重新获取。',
    invoiceNotAvailable: '支付完成后才可以下载账单。',
    invoiceGenerateFailed: '账单生成失败，请稍后重试，或联系工作人员处理。'
  }
}
